import React from "react";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Header from "./Header";
function Profile() {
  return (
    <>
      <div className="page-content header-clear-small">
        <Header />
        <br />
        <br />
        <br />

        <div className="card card-style">
          <div className="content mt-0 mb-0">
            <div className="list-group list-custom-large short-border check-visited">
              <Link to="/Productlist">
                <i
                 
                  class="fa fa-cubes bg-red-dark rounded-s rounded-s"
                  aria-hidden="true"
                ></i>
                <span>All Products</span>
                <i className="fa fa-angle-right"></i>
              </Link>

              <Link to="/terms">
                <i
                  class="fa fa-list-alt bg-blue-dark rounded-s"
                  aria-hidden="true"
                ></i>
                <span>Terms And Conditions</span>
                <i className="fa fa-angle-right"></i>
              </Link>

              <Link to="/privacy">
                <i
                  class="fa fa-file-text  bg-yellow-dark rounded-s"
                  aria-hidden="true"
                ></i>

                <span>Privacy Policy</span>
                <i className="fa fa-angle-right"></i>
              </Link>

              <Link to="/HelpAndSupport">
              <i  style={{ backgroundColor: "#ff7b56", color: "white" }} class="fa fa-user-circle rounded-s" aria-hidden="true"></i>
                <span>Help & Support</span>
                <i className="fa fa-angle-right"></i>
              </Link>

              <Link to="/Logout" className="border-0">
                <i
                  class="fa fa-sign-in  bg-mint-dark rounded-s "
                  aria-hidden="true"
                ></i>
                <span>Login</span>
                <i className="fa fa-angle-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Profile;
